import { isCalifornia } from "encamp-shared/src/constants/states";
import { KnownSubmissionDocumentTypes } from "encamp-shared/src/documents";

import type { DocumentMetadataFormData } from "../types";

const SUBMISSION_DOCUMENT_TYPES = new Set<string>(KnownSubmissionDocumentTypes);

type CurrentSubmissionFields = Pick<
  DocumentMetadataFormData,
  "offerCurrentSubmissionDocument" | "currentSubmissionDocument"
>;

export function isSubmissionDocumentType(documentType: string | null | undefined): boolean {
  return documentType != null && SUBMISSION_DOCUMENT_TYPES.has(documentType);
}

/**
 * Only a document with no facilities yet is offered the choice; otherwise its
 * existing per-facility flags stand. A refresh of the same document keeps the
 * form's values.
 */
export function initialCurrentSubmissionFields({
  isNewDocument,
  facilityCount,
  currentValues,
}: {
  isNewDocument: boolean;
  facilityCount: number;
  currentValues: CurrentSubmissionFields;
}): CurrentSubmissionFields {
  if (!isNewDocument) {
    return currentValues;
  }
  return {
    offerCurrentSubmissionDocument: facilityCount === 0,
    currentSubmissionDocument: undefined,
  };
}

/**
 * The mutation's flag; undefined leaves existing facility links as they are.
 * Until the user chooses, it carries forward only when one facility is linked,
 * since each facility's current document of that type would be replaced.
 */
export function currentSubmissionDocumentToSave(
  data: CurrentSubmissionFields & Pick<DocumentMetadataFormData, "documentType" | "facilities">
): boolean | undefined {
  if (!data.offerCurrentSubmissionDocument || !isSubmissionDocumentType(data.documentType)) {
    return undefined;
  }
  return data.currentSubmissionDocument ?? data.facilities?.length === 1;
}

export function hasNonCaliforniaFacility(
  facilities: DocumentMetadataFormData["facilities"]
): boolean {
  return (facilities ?? []).some((facility) => !isCalifornia(facility.state));
}
